<template>
  <el-tabs v-bind="$attrs" v-model="selectedValue" @tab-click="handleClick">
    <el-tab-pane
      v-for="(item, index) in tabList"
      :label="item.label"
      :name="item.name"
      :key="index"
    ></el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'RtTabs',
  props: {
    tabList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    handleClick(val) {
      this.$emit('input', val.name);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTabs.vue?8bbf5994